import React, { useEffect, useState, useCallback } from "react";
import { H1, Sub, Card } from "./Pages";
import { media as M } from "./lib/api";
import MediaUploader from "./components/MediaUploader";
import MediaGallery from "./components/MediaGallery";

const KINDS = [
  { k: "", label: "All" },
  { k: "image", label: "Images" },
  { k: "video", label: "Video" },
  { k: "audio", label: "Audio" },
  { k: "document", label: "Documents" },
];

export function MediaLibraryPage() {
  const [assets, setAssets] = useState(null);
  const [kind, setKind] = useState("");

  const load = useCallback(async () => {
    const r = await M.list("library");
    setAssets(r.data);
  }, []);
  useEffect(() => { load(); }, [load]);

  if (!assets) return <div>Loading…</div>;
  const shown = kind ? assets.filter((a) => a.kind === kind) : assets;

  return (
    <div data-testid="media-library-page">
      <H1>Media Library</H1>
      <Sub>Upload and organise images, video, audio, and documents. Large media upload in chunks with a live progress bar. Files are Private by default — switch any file to Shared to let all trustees view it.</Sub>

      <Card className="mb-5">
        <div className="label-caps mb-2">Upload to library</div>
        <MediaUploader contextType="library" showVisibility label="Choose files" onUploaded={load} testid="library-uploader" />
        <div className="text-xs mt-2" style={{ color: "var(--muted)" }}>Supports images, video, audio, PDF, Office docs and text — up to 500 MB each.</div>
      </Card>

      <div className="flex gap-2 mb-4 flex-wrap">
        {KINDS.map((k) => (
          <button key={k.k} className={kind === k.k ? "btn-primary" : "btn-outline"} onClick={() => setKind(k.k)} data-testid={`media-filter-${k.k || "all"}`}>
            {k.label} ({k.k ? assets.filter((a) => a.kind === k.k).length : assets.length})
          </button>
        ))}
      </div>

      <MediaGallery assets={shown} onChanged={load} />
    </div>
  );
}
